import { useContext } from 'react';

import { GetParams, useFetch } from '@uservoice/rest-utils';

import { getTeams, Team } from '@/core/api/collections/teams';
import { UserInviteContext } from '@/core/users/UserInvite/UserInviteContext';
import { EditTeams } from '@/core/users/UserPermissions/EditTeams';

export function UserInviteEditTeamsContainer () {
  const { selectedTeams, updateTeam } = useContext(UserInviteContext);
  const [teams, loading, error] = useFetch<GetParams, Team[]>(getTeams, { per_page: 100 });

  return (
    <EditTeams
      teams={teams}
      loading={loading}
      error={error}
      selectedTeams={selectedTeams}
      onChange={updateTeam}
    />
  );
}
